import React from 'react';
import { Box, VStack, HStack, Text, Button, Container } from '@chakra-ui/react';

import { useColorModeValue } from './chakra-ui/color-mode';
import { Link as RouterLink } from 'react-router-dom';
import { NAV_OFFSET } from './core/constants';
import { scrollToSection } from './core/scroll-to-section';
import './hero-section.css';
import { RiCameraLensFill } from 'react-icons/ri';
import { FaVideo } from 'react-icons/fa';
import { COLORS } from '../theme';
import { FONTS } from '../constants/fonts';
import SocialMediaLinks from './social-media';

function HeroSection() {
  const bgGradient = useColorModeValue(
    COLORS.gradients.hero.light,
    COLORS.gradients.hero.dark
  );
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const accentColor = useColorModeValue('gray.800', 'white');

  return (
    <>
      <Box
        bgGradient={bgGradient}
        minH={`calc(80vh - ${NAV_OFFSET}px)`}
        display="flex"
        alignItems="center"
        position="relative"
        overflow="hidden"
      >
        <Container>
          <VStack
            spacing={{ base: 14, md: 24 }} // Deep vertical rhythm
            textAlign="center"
            py={{ base: 12, md: 20 }}
            mb={0}
            position="relative"
            zIndex={1}
          >
            {/* Logo Group (Identity) */}
            <VStack spacing={0} w="full">
              <HStack
                justify="center"
                alignItems="baseline"
                gap={3}
                position="relative"
              >
                <Text
                  className="title-main"
                  fontFamily={FONTS.accent}
                  color={accentColor}
                  whiteSpace="nowrap"
                >
                  ViAn
                </Text>
                <Box>
                  <FaVideo
                    style={{
                      fontSize: '1.25rem',
                      color: COLORS.brandHex.primary
                    }}
                  />
                </Box>
              </HStack>

              <HStack justify="center" align="center" gap={0} mb={5}>
                <Text className="title-secondary" fontFamily={FONTS.heading}>
                  PHOT
                </Text>
                <Box>
                  <RiCameraLensFill
                    className="lens-icon"
                    style={{ color: COLORS.brandHex.primary }}
                  />
                </Box>
                <Text className="title-secondary" fontFamily={FONTS.heading}>
                  GRAPHY
                </Text>
              </HStack>
            </VStack>

            {/* Vision Group (Headline + Desc) */}
            <VStack spacing={8} maxW="5xl">
              <Text
                fontSize="2xl"
                color={textColor}
                maxW="3xl"
                lineHeight="tall"
                fontWeight="medium"
              >
                Capturing Life's Beautiful Moments
              </Text>

              <Text
                fontSize={{ base: 'sm', md: 'lg' }}
                color={textColor}
                lineHeight="1.8"
                maxW="xl"
                px={4}
                opacity={0.65}
              >
                Creating stunning visual stories that last a lifetime through
                professional portraits, weddings, and commercial photography.
              </Text>
            </VStack>

            {/* Action Group (CTA) */}
            <Box pt={4}>
              <Button
                colorScheme="orange"
                size="lg"
                minH="48px"
                minW="240px"
                px={{ base: 6, md: 8 }}
                _hover={{ transform: 'translateY(-2px)', shadow: 'xl' }}
                transition="all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
                as={RouterLink}
                to="/#contact"
                borderRadius="full"
                shadow="xl"
                onClick={e => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}
              >
                Get in Touch
              </Button>

              <Box mt={4} width={'100%'}>
                <SocialMediaLinks />
              </Box>

            </Box>
          </VStack>
        </Container>
      </Box>
    </>
  );
}

export default HeroSection;
